<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <time-condition-sound-file-input :label="$t('file')" v-model="soundFileFormData.file" :placeholder="$t('time_conditions_upload_file_choose_file')"></time-condition-sound-file-input>
        <validation-error :model-error="soundFileFormErrors.file"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import TimeCondition from '@/models/TimeCondition'
import TimeConditionSoundFileInput from '@/components/form-inputs/TimeConditionSoundFileInput'

export default {
  name: 'Shared.SoundFiles.Add',
  components: {
    TimeConditionSoundFileInput
  },
  data () {
    return {
      soundFileFormData: {
        file: null,
        timeGroupIndex: this.$route.params.index,
        timeGroupList: this.$route.params.list
      },
      soundFileFormErrors: []
    }
  },
  mounted () {
    EventBus.$on('initSoundFileFormData', this.initSoundFileFormData)
    EventBus.$on('initAddSoundFile', this.addSoundFile)
  },
  methods: {
    initSoundFileFormData () {
      this.soundFileFormData = {
        file: null
      }
      this.soundFileFormErrors = {}
    },
    async addSoundFile () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addSoundFileButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await TimeCondition.storeSoundFile(this.soundFileFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.initSoundFileFormData()
          this.$emit('addSoundFileSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.soundFileFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#addSoundFileButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#addSoundFileButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
